import * as React from "react";

/**
 * 403页面
 */
export default () => {
    return (
        <div className="notfound-wrapper flexc flexjc flexic h">
            <img src={require('../../assets/images/icon-404.png')} alt=""/>
            <h1 style={{fontFamily: 'Arial', fontSize: 80, color: '#1890ff'}}>403</h1>
            <p className="f18">暂无权限</p>
        </div>
    )
}
